<template>
  <v-container :key="updateKey">
    <v-row v-if="parsedData">
      <v-col
        v-for="(total, i) in parsedData.totals"
        :key="i"
        cols="12"
        sm="6"
        lg="4"
      >
        <material-stats-card
          color="primary"
          :title="total.name"
          :value="total.value ? Math.round(total.value).toString() : ''"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="parsedData"
    >
      <v-col
        v-for="(daily, i) in Object.entries(parsedData.daily)"
        :key="i"
        cols="12"
        lg="6"
      >
        <chart
          :y-axis="[{
            gridLineWidth: 1,
            title: {
              text: daily[0]
            }
          }]"
          :start="moment(dates.start).utc()"
          :series="daily[1]"
        />
      </v-col>
    </v-row>
    <v-row v-if="parsedData">
      <v-col
        cols="12"
      >
        <v-data-table
          :headers="headers"
          :items="parsedData.rows"
        />
      </v-col>
      <v-col
        cols="12"
        class="text-right"
      >
        <vue-json-to-csv
          :json-data="parsedData.rows"
          :csv-title="'Site data from ' + moment(dates.start).format('DD-MM-YY') + ' to ' + moment(dates.end).format('DD-MM-YY')"
        >
          <v-btn
            color="primary"
          >
            Download
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import Chart from '../core/Chart.vue'
  import VueJsonToCsv from 'vue-json-to-csv'
  export default {
    name: 'Traffic',
    components: {
      Chart,
      VueJsonToCsv
    },
    props: {
      dates: {
        type: Object,
        required: true
      },
      toggleLoading: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      parsedData: null,
      trafficData: null,
      headers: [],
      updateKey: 0
    }),
    computed: {
      site: function () {
        return this.$store.state.site
      },
    },
    mounted () {
      this.getTrafficData()
    },
    methods: {
      moment,
      getTrafficData () {
        this.toggleLoading()
        if (this.site) {
          var start = moment(this.dates.start).unix()
          var end = moment(this.dates.end).unix()
          var route = 'analytics/' + this.site + '/' + start + '/' + end
          this.api.get(route)
            .then(result => {
              this.trafficData = result.data
              this.parseTrafficData()
              this.toggleLoading()
            }, error => {
              this.toggleLoading()
              this.error = error
            })
        }
      },
      parseTrafficData () {
        var data = this.trafficData
        console.log(data)
        if (data && data.length > 0) {
          var metrics = ['Page Views', 'Sessions', 'Unique Users', 'Avg Session In Seconds']
          var parsedData = {
            totals: [],
            rows: [],
            daily: {}
          }

          // fill totals
          if (data[0].rows && data[0].rows.length > 0) {
            data[0].rows[0].forEach((value, i) => {
              parsedData.totals.push({
                name: metrics[i],
                value
              })
            })
          }

          if (data.length > 0 && data[1].rows) {
            // fill table
            var headers = [{ text: 'Date', value: 'date', align: 'left' }]
            data[1].rows.forEach((row, i) => {
              var newRow = {
                date: this.moment(this.dates.start).add(i, 'days').format('DD-MM-YY')
              }
              metrics.forEach((metric, j) => {
                newRow[metric] = row[j + 1]
              })
              parsedData.rows.push(newRow)
            })

            // fill graph
            metrics.forEach((metric, i) => {
              headers.push({
                text: metric,
                value: metric,
                align: 'right'
              })
              var serie = {
                name: metric,
                data: [],
              }
              parsedData.daily[metric] = []

              data[1].rows.forEach(row => {
                serie.data.push(parseInt(row[i + 1]))
              })
              console.log(serie.data.length)
              parsedData.daily[metric].push(serie)
            })

            this.headers = headers
          }
          this.parsedData = parsedData
          this.updateKey++
        }
      }
    },

  }
</script>
